import React, { FC } from 'react';

import Checkbox from '@/components/ui/Checkbox';
import cn from '@/utils/cn';

import { cva } from 'class-variance-authority';

const checkBoxGroup = cva('', {
  variants: {
    layout: {
      horizontal: [
        'grid grid-cols-1 gap-3 md:grid-cols-2 md:flex-row md:gap-5.5',
      ],
      vertical: ['flex flex-col gap-3'],
    },
  },
});

export interface Options {
  value: string;
  label: string;
  willResetRest?: boolean;
}

interface Props {
  field: {
    value: Options[];
    onChange: (value: Options[]) => void;
  };
  options: Options[];
  layout?: 'horizontal' | 'vertical';
  variant?: 'default' | 'filled';
  ['data-testid']?: string;
}

const CheckboxGroup: FC<Props> = ({
  field,
  options,
  variant = 'filled',
  layout = 'horizontal',
  ...props
}) => {
  return (
    <div className={cn('scroll-mt-0', checkBoxGroup({ layout }))} {...props}>
      {options.map((option) => {
        return (
          <Checkbox
            key={option.value}
            data-testid={`${props['data-testid'] ? props['data-testid'] : ''}-checkbox-${option.value}`}
            variant={variant}
            label={option.label}
            checked={
              field.value
                ?.map((item: Options) => item.value)
                ?.includes(option.value) || false
            }
            onCheckedChange={(checked) => {
              if (checked) {
                if (option.willResetRest) {
                  field.onChange([option]);
                } else {
                  field.onChange([
                    ...(field.value ?? []).filter(
                      (item) => !item.willResetRest
                    ),
                    option,
                  ]);
                }
              } else {
                field.onChange(
                  field.value?.filter((item) => item.value !== option.value)
                );
              }
            }}
          />
        );
      })}
    </div>
  );
};

export default CheckboxGroup;
